import type { InstagramPostType } from '@pulsify/shared/dto'
import { Instagram } from 'lucide-react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { useCreateInstagramPost } from '~/entities/crossposting/model/use-facebook-post'
import {
  type ComposerConfig,
  SocialPostComposer,
} from '~/features/crossposting/components/social-post-composer'
import * as m from '~/paraglide/messages'

const INSTAGRAM_CONFIG: ComposerConfig = {
  platform: 'instagram',
  title: m.crosspostingInstagramTitle,
  description: m.crosspostingInstagramDescription,
  publishLabel: m.crosspostingPublishInstagram,
  publishedLabel: m.crosspostingPublishedInstagram,
  icon: Instagram,
  types: [
    {
      value: 'post',
      label: m.crosspostingIgPost,
      hint: m.crosspostingIgPostHint,
      maxImages: 10,
      mediaRequired: true,
    },
    {
      value: 'reel',
      label: m.crosspostingIgReel,
      hint: m.crosspostingIgReelHint,
      disabled: true,
      maxImages: 0,
      mediaRequired: false,
    },
    {
      value: 'story',
      label: m.crosspostingIgStory,
      hint: m.crosspostingIgStoryHint,
      maxImages: 1,
      mediaRequired: true,
    },
  ],
}

export function InstagramPostTool({ listingId }: { listingId: string }) {
  const { data: business } = useCurrentBusiness()
  const createPost = useCreateInstagramPost(business?.id ?? '', listingId)

  return (
    <SocialPostComposer
      listingId={listingId}
      config={INSTAGRAM_CONFIG}
      onPublish={async ({ type, text, files }) => {
        await createPost.mutateAsync({
          payload: { type: type as InstagramPostType, text: text.trim() || undefined },
          files,
        })
      }}
    />
  )
}
